<template>
  <Suggestion :placement="placement">
    <template #suggestContent>
      <p style="padding: 10px; width: 350px; margin: 0px">
        {{ hpcInfo }}
      </p>
    </template>
    <template #shownElement>
      <span :style="elementStyle">高潛力消費者(HPC)</span><span v-if="shownElementOtherWord">{{ shownElementOtherWord }}</span>
    </template>
  </Suggestion>
</template>

<script>

import Suggestion from '@/views/Suggestion'

export default {
  name: 'HpcSuggestion',
  components: { Suggestion },
  props: {
    shownElementOtherWord: {
      type: String
    },
    placement: {
      type: String,
      default: 'top-start'
    },
    elementStyle: {
      type: String,
      default: 'text-decoration: underline; cursor: pointer;'
    }
  },
  data () {
    return {
      hpcInfo: '當消費者在非影音內容網站 (Outstream) 觀看相關產業的影音廣告，觀看長度在桌機達 50% 或行動裝置達 25% 以上或採取點擊等行動，即反映了對該產業有關注/興趣，OneAD 將其定義為 HPC'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
